import { render, staticRenderFns } from "./ProductDisplay.vue?vue&type=template&id=67a5bbdc&scoped=true&lang=pug"
import script from "./ProductDisplay.vue?vue&type=script&lang=js"
export * from "./ProductDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProductDisplay.vue?vue&type=style&index=0&id=67a5bbdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5bbdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a5bbdc')) {
      api.createRecord('67a5bbdc', component.options)
    } else {
      api.reload('67a5bbdc', component.options)
    }
    module.hot.accept("./ProductDisplay.vue?vue&type=template&id=67a5bbdc&scoped=true&lang=pug", function () {
      api.rerender('67a5bbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductDisplay.vue"
export default component.exports